/** @jsxImportSource @emotion/react */
import { Col, Container, ListGroup, ListGroupItem, Row } from "reactstrap";
import { SupplierPortalProvider, useSupplierPortal } from "../../../context/SupplierPortal";
import FullPageLayout from "../Layout/FullPageLayout";
import StyledBox from "../Layout/StyledBox";
import Reports from "./Reports";

export const SupplierPortal = () => (
    <SupplierPortalProvider>
        <SupplierPortalPage />
    </SupplierPortalProvider>
);

export const SupplierPortalPage = () => {
    const { tenants, onTenantSelect, selectedTenant, hasMultipleSuppliers, tenantsBySupplier } = useSupplierPortal();

    return (
        <FullPageLayout>
            <Container className="py-md-5 py-3">
                <Row className="g-5">
                    {/* Left Side: Tenants */}
                    {/* @TODO: Use select on mobile? */}
                    <Col xs="3" sm="3" md="2" className="border-right p-3">
                        {!!tenants?.length && !hasMultipleSuppliers && <h6 className="mb-2 text-muted fs-6">Clients</h6>}

                        {Object.values(tenantsBySupplier ?? {}).map((items, i) => (
                            <div className="mb-4" key={`${items[0].supplier_id}-${i}`}>
                                {hasMultipleSuppliers && <h6 className="mb-2 text-muted fs-6">{items[0].supplier_name}</h6>}

                                <ListGroup>
                                    {items.map((tenant, index) => (
                                        <ListGroupItem
                                            key={index}
                                            tag="button"
                                            action
                                            onClick={() => onTenantSelect(tenant)}
                                            active={
                                                tenant.id === selectedTenant?.id
                                                && tenant.supplier_id === selectedTenant?.supplier_id
                                            }
                                        >
                                            {tenant.label}
                                        </ListGroupItem>
                                    ))}
                                </ListGroup>
                            </div>
                        ))}
                    </Col>

                    {/* Right Side: Reports */}
                    <Col xs="9" sm="9" md="10">
                        <StyledBox>
                            <h4 className="text-muted fs-6 fw-bold border-bottom pb-2 mb-4">Reports</h4>

                            <Reports />
                        </StyledBox>
                    </Col>
                </Row>
            </Container>
        </FullPageLayout>
    );
};
